import HelpDetails from './HelpDetails'

export default HelpDetails
